import { render } from "./ExamManagement.vue?vue&type=template&id=9ae6b1ea&scoped=true"
import script from "./ExamManagement.vue?vue&type=script&lang=js"
export * from "./ExamManagement.vue?vue&type=script&lang=js"

import "./ExamManagement.vue?vue&type=style&index=0&id=9ae6b1ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae6b1ea"]])

export default __exports__